import { useEffect } from 'react';

// Calls onTick every animation frame while active.
export const useTicker = (active, onTick) => {
  useEffect(() => {
    if (!active) return undefined;
    let id;
    const loop = () => { onTick(Date.now()); id = requestAnimationFrame(loop); };
    id = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(id);
  }, [active, onTick]);
};
